import httpUtil from "@/utils/httpUtil";

export const selectFilingList = params => httpUtil.get("/hzp/filingInfo", params);
export const addOrUpdateFiling = params => httpUtil.post("/hzp/filingInfo", params);
export function fetchDelFiling(id) {
    return httpUtil.delete(`/hzp/filingInfo/delete/${id}`)
}

export const selectFilings = params => httpUtil.get("/hzp/filingInfo/all", params);
export const selectFilingDetail = params => httpUtil.get("/hzp/filingInfo/detail", params);

export const selectFilingInfo = params => httpUtil.get("/hzp/filingInfo/getInfo", params);